import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Content = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49996 2H14.5001C15.6047 2 16.5002 2.89545 16.5001 4.00004L16.4999 16C16.4999 17.1046 15.6045 18 14.4999 18L5.49987 18C4.3953 18 3.49987 17.1045 3.49988 15.9999L3.49996 3.99999C3.49996 2.89542 4.39539 2 5.49996 2ZM7.00018 5.25C6.58597 5.25 6.25018 5.58579 6.25018 6C6.25018 6.41421 6.58597 6.75 7.00018 6.75H13.0002C13.4144 6.75 13.7502 6.41421 13.7502 6C13.7502 5.58579 13.4144 5.25 13.0002 5.25H7.00018ZM7.00018 8.25C6.58597 8.25 6.25018 8.58579 6.25018 9C6.25018 9.41421 6.58597 9.75 7.00018 9.75H13.0002C13.4144 9.75 13.7502 9.41421 13.7502 9C13.7502 8.58579 13.4144 8.25 13.0002 8.25H7.00018ZM7.00018 11.25C6.58597 11.25 6.25018 11.5858 6.25018 12C6.25018 12.4142 6.58597 12.75 7.00018 12.75H10.0002C10.4144 12.75 10.7502 12.4142 10.7502 12C10.7502 11.5858 10.4144 11.25 10.0002 11.25H7.00018Z"
        fill="url(#paint0_linear_2721_29277)"
      />
      <defs>
        <linearGradient id="paint0_linear_2721_29277" x1="10" y1="2" x2="10" y2="18" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2AB5F0" />
          <stop offset="1" stopColor="#0093D2" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Content
